module.exports = __webpack_public_path__ + "img/offer_img.7b38cd3.webp";